var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgFrantoiIcon = function SvgFrantoiIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.271 43.592.02-.07-9.392-36.373A5.4 5.4 0 0 0 25.5 1.752a5.4 5.4 0 0 0-5.397 5.397l-9.468 36.672.02.051a15.309 15.309 0 0 0-.53 3.994c0 8.492 6.884 15.37 15.37 15.37 8.484 0 15.368-6.885 15.368-15.37 0-1.486-.217-2.922-.606-4.28l.013.006Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.508 12.547a5.397 5.397 0 1 0 0-10.795 5.397 5.397 0 0 0 0 10.795Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.206 13.16H49.05L37.732 33.631 30.892 7.15a5.4 5.4 0 0 0-5.397-5.397 5.4 5.4 0 0 0-5.397 5.397l-2.578 9.985c-.121 0-.249-.006-.37-.006-8.491 0-15.369 6.884-15.369 15.369 0 5.997 3.432 11.184 8.44 13.723a15.645 15.645 0 0 0-.095 1.652c0 8.492 6.884 15.37 15.37 15.37 8.484 0 15.368-6.884 15.368-15.37 0-.319-.012-.631-.031-.944l10.36-33.762.013-.007Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
var Memo = /*#__PURE__*/memo(SvgFrantoiIcon);
export { Memo as ReactComponent };
export default "/_next/static/svg/b13d7f6d3932cbbad52eb2ab85f17829.svg";